export default __webpack_public_path__ + "340bd1dffdd4ae24aa4d875a203697b6.gif";